import type { CSSProperties, InputHTMLAttributes, ReactNode } from 'react';
import styles from './default-pill-input.module.scss';

interface DefaultPillInputProps extends InputHTMLAttributes<HTMLInputElement> {
  htmlFor?: string;
  label?: ReactNode;
  containerStyle?: CSSProperties;
  containerClassName?: string;
  inputWrapperClassName?: string;
  errorMessage?: ReactNode;
  error?: boolean;
  labelColor?: string;
  leftTag?: ReactNode;
}

export const DefaultPillInput = ({
  containerClassName,
  labelColor,
  leftTag,
  disabled,
  error,
  errorMessage,
  containerStyle,
  label,
  htmlFor,
  type,
  inputWrapperClassName,
  ...rest
}: DefaultPillInputProps) => {
  const labelStyle = labelColor ? { color: labelColor } : undefined;
  const isError = error || !!errorMessage;

  return (
    <div
      className={`${styles.pillInputContainer} ${containerClassName || ''} ${
        disabled ? styles.disabled : ''
      } ${isError ? styles.error : ''}`}
      style={{ ...containerStyle, ...labelStyle }}
    >
      {label ? <label htmlFor={htmlFor}>{label}</label> : null}
      <div>
        <div
          className={`${styles.inputWrapper} ${inputWrapperClassName || ''}`}
        >
          {leftTag ? (
            <span className={styles.leftTag}>{leftTag}</span>
          ) : (
            <div className={styles.leftTag} />
          )}
          <input disabled={disabled} type={type} {...rest} />
        </div>
        {errorMessage ? (
          <small className="text-error">{errorMessage}</small>
        ) : null}
      </div>
    </div>
  );
};
